import { createContext } from 'react';

import { DEFAULT_LANGUAGE } from './constants';

export default createContext({
  language: DEFAULT_LANGUAGE,
  switchLanguage: () => {},
});
